module.exports = __webpack_public_path__ + "static/the-wright-brothers-c0ee3e208e184dfeff4998b93e231551.jpg";